import * as dom from "@/wc/registry/lib/dom/index.js";

export function closeSurroundingModal(element: Element) {
    const modal = getModal(element);

    if (modal) {
        modal.remove();
    }
}

// Using a type predicate to narrow down the type to make sure that the passed
// node is actually a c-modal.
// https://www.typescriptlang.org/docs/handbook/2/narrowing.html#using-type-predicates
function isModal(
    node: Node | ShadowRoot
): node is HTMLElementTagNameMap["c-modal"] {
    return dom.isMatchingElement(node, "c-modal");
}

// Traverse up the tree until we find a modal.
export function getModal(
    context: Node | ShadowRoot
): HTMLElementTagNameMap["c-modal"] | undefined {
    let modal: HTMLElementTagNameMap["c-modal"] | undefined;
    let currentNode = context;
    while (currentNode) {
        currentNode = dom.getParentOrHost(currentNode);
        if (isModal(currentNode)) {
            modal = currentNode;
            break;
        }
    }
    return modal;
}
